import { CRM_API, RequestHelper } from "utils";

const RUTA = "archivo";
export const ArchivoService = (() => {
  const grabar = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).postWithFiles(`${RUTA}/grabar`, data);
    });
  };

  const listado = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/listar`, params);
    });
  };

  const descargarPorId = function (args) {
    return new Promise((res) => res(args)).then((Id) => {
      return RequestHelper(CRM_API).get(
        `${RUTA}/descargarPorId`,
        {
          Id: Id,
        },
        true
      );
    });
  };

  const inactivarArchivo = function (args) {
    return new Promise((res) => res(args)).then((Id) => {
      return RequestHelper(CRM_API).get(`${RUTA}/Inactivar/${Id}`);
    });
  };

  const listarDocumentos = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/ListarDocumentos`, params);
    });
  };

  const adjuntarDocumentos = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).postWithFiles(`${RUTA}/AdjuntarDocumentos`, data);
    });
  };

  const descargarDocumentoPorId = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(
        `${RUTA}/DescargarDocumentoPorId`,
        params,
        true
      );
    });
  };

  const borrarDocumentoPorId = function (args) {
    return new Promise((res) => res(args)).then((Id) => {
      return RequestHelper(CRM_API).get(`${RUTA}/BorrarDocumentoPorId`, {
        Id: Id,
      });
    });
  };

  return {
    grabar,
    listado,
    descargarPorId,
    listarDocumentos,
    adjuntarDocumentos,
    descargarDocumentoPorId,
    borrarDocumentoPorId,
    inactivarArchivo
  };
})();
